<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5321 9.33334H22.8748L17.7567 15.183L23.7778 23.143H19.0634L15.3709 18.3153L11.1458 23.143H8.80169L14.276 16.8862L8.5 9.33334H13.3341L16.6718 13.7461L20.5321 9.33334ZM19.7099 21.7408H21.008L12.6287 10.6619H11.2357L19.7099 21.7408Z"/>
  </svg>
</template>